import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/components/views/homepage/HomePage'
import Products from '@/components/views/products/products'
import Contact from '@/components/views/contact/contact'
import AboutUs from '@/components/views/about-us/about-us'
import Error404 from '@/components/contents/404'
import Accounting from '@/components/contents/products/accounting/accounting'
import Inventory from '@/components/contents/products/inventory/inventory'
import Payroll from '@/components/contents/products/payroll/payroll'
import Document from '@/components/contents/products/document/document'
import fixedAsset from '@/components/contents/products/fixed-asset/fixed-asset'
import biometric from '@/components/contents/services/biometric/biometric'
import software from '@/components/contents/services/development/development'
import Solutions from '@/components/views/solutions/solutions'
import Services from '@/components/views/services/services'
// import contact from '@/components/contents/training'

Vue.use(Router)

export default new Router({
  mode: 'history',
  linkExactActiveClass: "nav-active",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path:'*',
      component :Error404,
    },
    {
      path: '/',
      component: HomePage,
    },
    {
      path: '/products',
      name: 'products',
      component: Products,
    },
    {
      path: '/what-we-build',
      name: 'solutions',
      component: Products,
      // component: Solutions,
    },
    {
      path: '/what-we-do',
      name: 'services',
      component: Services,
    },
    {
      path: '/contact-us',
      name: 'contact',
      component: Contact,
    },
    {
      path: '/who-we-are',
      name: 'about-us',
      component: AboutUs,
    },
    {
      path: '/accounting-software',
      name: 'accounting',
      component: Accounting,
    },
    {
      path: '/document-software',
      name: 'document',
      component: Document,
    },
    {
      path: '/payroll-software',
      name: 'payroll',
      component: Payroll,
    },
    {
      path: '/fixed-asset-software',
      name: 'fixed-asset',
      component: fixedAsset,
    },
    {
      path: '/inventory-software',
      name: 'inventory',
      component: Inventory,
    },
    {
      path: '/services/biometric-registration',
      name: 'biometric',
      component: biometric,
    },
    {
      path: '/services/software-development',
      name: 'software development',
      component: software,
    },


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js